<template>
  <md-menu
    class="nav__notifications"
    :md-active.sync="isNotificationCardOpen"
    md-align-trigger
    md-direction="bottom-end"
    data-test-id="notifications"
  >
    <md-button
      md-menu-trigger
      class="nav__notifications-btn"
      data-test-id="notifications-toggle-btn"
      :md-ripple="false"
    >
      <md-tooltip
        md-direction="bottom"
        class="custom-tooltip"
        :style="{ width: 'fit-content' }"
        :md-active.sync="tooltipActive"
        data-test-id="notifications-tooltip"
      >
        {{ i18n.lbl_notifications() }}
      </md-tooltip>
      <md-icon
        md-src="/static/img/bell.svg"
        :class="{ 'md-icon_active': isNotificationCardOpen }"
        data-test-id="notifications-toggle-btn-icon"
      />
      <span class="nav__notifications-label text_large">
        <span class="nav__notifications-counter" data-test-id="notifications-counter">
          ({{ notifCounter }})
        </span>
      </span>
    </md-button>

    <md-menu-content
      v-if="notifCounter > 0"
      ref="notifContainer"
      class="redesign-menu nav__notifications-menu"
      data-test-id="notifications-list-container"
    >
      <template v-if="getUnreadMessages.length > 0">
        <md-menu-item
          v-for="(msg, index) in getUnreadMessages"
          :key="`unread_${msg.message_key}`"
          class="nav__notifications-item"
          :data-test-id="`notifications-list-item-${msg.message_key}`"
          :ref="index === getUnreadMessages.length - 1 ? 'lastUnreadMessage' : null"
        >
          <span class="nav__notifications-content">
            {{ getMessageText(msg) }}
          </span>

          {{ checkRead(msg.id)}}
        </md-menu-item>
      </template>

      <template v-if="getUnreadInc.length > 0">
        <md-menu-item
          class="notify_aml_title"
          data-test-id="notifications-list-item-title"
        >
          <span class="nav__notifications-content">
            > {{ i18n.lbl_aml_notify_inc() }}
          </span>
        </md-menu-item>
        <md-menu-item
          v-for="inc in getUnreadInc"
          :key="`aml_${inc.id}`"
          class="nav__notifications-item notify_aml"
          @click="openDialog(inc.id, 2)"
          :data-notif-id="inc.notif_id"
          :data-test-id="`notifications-list-item-${inc.notif_id}`"
        >
          <span class="nav__notifications-content nav__notifications-content_indent">
            <span class="notif-date">{{inc.timeStamp}}</span>
            {{i18n.lbl_aml_title()}}
          </span>
        </md-menu-item>
      </template>

      <template v-if="getUnreadOut.length > 0">
        <md-menu-item
          class="notify_aml_title"
          data-test-id="notifications-list-item-title"
        >
          <span class="nav__notifications-content">
            > {{ i18n.lbl_aml_notify_out() }}
          </span>
        </md-menu-item>
        <md-menu-item
          v-for="out in getUnreadOut"
          :key="`inc_${out.id}`"
          class="nav__notifications-item notify_aml"
          @click="openDialog(out.id, 3)"
          :data-notif-id="out.notif_id"
          :data-test-id="`notifications-list-item-${out.notif_id}`"
        >
          <span class="nav__notifications-content nav__notifications-content_indent">
            <span class="notif-date">{{out.timeStamp}}</span>
            {{i18n.lbl_aml_title()}}
          </span>
        </md-menu-item>
      </template>

      <template v-if="getUnreadLymit.length > 0">
        <md-menu-item
          class="notify_aml_title"
          data-test-id="notifications-list-item-title"
        >
          <span class="nav__notifications-content">
            > {{ i18n.lbl_limit_title() }}
          </span>
        </md-menu-item>
        <md-menu-item
          v-for="lymit in getUnreadLymit"
          :key="`lymit_${lymit.id}`"
          class="nav__notifications-item notify_aml"
          @click="$emit('openLymitDialog', lymit.id)"
          :data-notif-id="lymit.notif_id"
          :data-test-id="`notifications-list-item-${lymit.notif_id}`"
        >
          <span class="nav__notifications-content nav__notifications-content_indent">
            <span class="notif-date">{{lymit.timeStamp}}</span>
            {{i18n.lbl_limit_s()}}
          </span>
        </md-menu-item>
      </template>

      <template v-if="getUnreadErrorOut.length > 0">
        <md-menu-item
          class="nnotify_aml_title"
          data-test-id="notifications-list-item-title"
        >
          <span class="nav__notifications-content">
            > {{ i18n.lbl_aml_error_out() }}
          </span>
        </md-menu-item>
        <md-menu-item
          v-for="outerror in getUnreadErrorOut"
          :key="`out_${outerror.id}`"
          class="nav__notifications-item notify_aml"
          @click="openDialog(outerror.id, -2)"
          :data-notif-id="outerror.notif_id"
          :data-test-id="`notifications-list-item-${outerror.notif_id}`"
        >
          <span class="nav__notifications-content nav__notifications-content_indent">
            <span class="notif-date">{{outerror.timeStamp}}</span>
            {{i18n.lbl_aml_title()}}
          </span>
        </md-menu-item>
      </template>

      <template v-if="getUnreadErrorInc.length > 0">
        <md-menu-item
          class="notify_aml_title"
          data-test-id="notifications-list-item-title"
        >
          <span class="nav__notifications-content">
            > {{ i18n.lbl_aml_error_inc() }}
          </span>
        </md-menu-item>
        <md-menu-item
          v-for="incerror in getUnreadErrorInc"
          :key="`out_${incerror.id}`"
          class="nav__notifications-item notify_aml"
          @click="openDialog(incerror.id, -1)"
          :data-notif-id="incerror.notif_id"
          :data-test-id="`notifications-list-item-${incerror.notif_id}`"
        >
          <span class="nav__notifications-content nav__notifications-content_indent">
            <span class="notif-date">{{incerror.timeStamp}}</span>
            {{i18n.lbl_aml_title()}}
          </span>
        </md-menu-item>
      </template>
    </md-menu-content>

    <md-menu-content
      v-else
      class="redesign-menu nav__notifications-menu"
      data-test-id="notifications-empty-list-container"
    >
      <md-menu-item data-test-id="notifications-empty-list-item">
        <div class="nav__notifications-content">
          {{ i18n.notification_no_new_notifications() }}
        </div>
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
  import { vuexTypes } from '@vuex/types'
  import { mapGetters, mapActions } from 'vuex'
  import { i18n } from '@js/i18n'

  export default {
    name: 'Notifications',

    data: () => ({
      i18n,
      isNotificationCardOpen: false,
      ids: [],
      tooltipActive: false,
      notifContainerRef: null,
      isScrolledToEnd: false,
      isScrolledToMessagesEnd: false
    }),

    computed: {
      ...mapGetters({
        getUnreadMessages: vuexTypes.getUnreadMessages,
        getUnreadErrorInc: 'getUnreadErrorInc',
        getUnreadErrorOut: 'getUnreadErrorOut',
        getUnreadLymit: 'getUnreadLymit',
        getUnreadInc: 'getUnreadInc',
        getUnreadOut: 'getUnreadOut'
      }),
      notifCounter () {
        return this.getUnreadMessages.length +
          this.getUnreadErrorInc.length +
          this.getUnreadErrorOut.length +
          this.getUnreadLymit.length +
          this.getUnreadInc.length +
          this.getUnreadOut.length
      },
      messageMap () {
        return {
          transaction_income: this.i18n.notification_transaction_income,
          transaction_emission: this.i18n.notification_transaction_emission,
          transaction_exchange: this.i18n.notification_transaction_exchange,
          contract_money_lock: this.i18n.notification_contract_money_lock,
          kyc_to_not_verified: this.i18n.notification_kyc_to_not_verified,
          kyc_approve: this.i18n.notification_kyc_approve, // Нотиф об верефикации
          kyc_reject: this.i18n.notification_kyc_reject
        }
      }
    },

    watch: {
      tooltipActive (newVal) {
        if (newVal && this.isNotificationCardOpen) {
          this.$nextTick(() => {
            this.tooltipActive = false
          })
        }
      },

      async isNotificationCardOpen (newVal, oldVal) {
        if (newVal) {
          this.tooltipActive = false

          try {
            await this.$nextTick()

            const notifContainer = this.$refs.notifContainer
            if (notifContainer && notifContainer.$el && notifContainer.$el.children[0]) {
              this.notifContainerRef = notifContainer.$el.children[0]
              this.isScrolledToEnd = false
              this.isScrolledToMessagesEnd = false
              this.notifContainerRef.addEventListener('scroll', this.onMenuScroll)
            } else {
              console.warn('Notification container ref not found')
              this.notifContainerRef = null
            }
          } catch (error) {
            console.error('Error setting up notification container:', error)
            this.notifContainerRef = null
            this.isScrolledToEnd = false
            this.isScrolledToMessagesEnd = false
          }
        }

        if (!newVal) {
          try {
            if (this.notifContainerRef) {
              this.notifContainerRef.removeEventListener('scroll', this.onMenuScroll)
              this.notifContainerRef = null
            }
          } catch (error) {
            console.error('Error removing scroll listener:', error)
            // Ensure cleanup even if removeEventListener fails
            this.notifContainerRef = null
          }
        }

        if (!newVal && oldVal) {
          try {
            this.notificationMenuRefreshed()
          } catch (error) {
            console.error('Error refreshing notification menu:', error)
          }
        }
      }
    },

    methods: {
      ...mapActions({
        MARK_READ_MESSAGES: vuexTypes.MARK_READ_MESSAGES
      }),
      getMessageText (msg) {
        const fn = this.messageMap[msg.message_key]
        return fn ? fn(msg.params) : msg.message_key // fallback
      },
      checkRead (id) {
        if (this.isNotificationCardOpen && this.ids.indexOf(id) === -1) {
          this.ids.push(id)
        }
      },
      notificationMenuRefreshed () {
        if (!this.isNotificationCardOpen) this.sendReadInfo()
      },
      sendReadInfo () {
        if (this.ids.length > 0) {
          // Send request to read endpoint
          this.MARK_READ_MESSAGES(this.ids)
          this.ids = []
        }
      },
      openDialog (id, type) {
        this.$emit('openDialog', { id, type })
      },

      onMenuScroll (event) {
        const el = event.target
        // проверка, дошли ли до конца
        this.isScrolledToEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 1

        // Проверка для блока getUnreadMessages
        const lastMessageEl = this.$refs.lastUnreadMessage
        if (lastMessageEl && lastMessageEl[0]) {
          const targetElement = lastMessageEl[0].$el || lastMessageEl[0]
          const rect = targetElement.getBoundingClientRect()
          const containerRect = el.getBoundingClientRect()

          // Проверить, виден ли элемент в контейнере
          this.isScrolledToMessagesEnd = rect.bottom <= containerRect.bottom
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../scss/mixins";
  @import "../../scss/variables";

  .notify_aml {
    cursor: pointer;

    &_title {
      font-size: 18px;
    }
  }

  .notif-date {
    font-weight: bold;
  }

  .nav__notifications {
    position: relative;

    &-counter {
      @include font('main', $font-size-l, 400);
      color: $default-white;
    }

    &-btn {
      &.md-button {
        &:before {
          content: none;
        }

        /deep/ .md-ripple {
          padding: 0;
        }

        /deep/ .md-button-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .md-icon {
          margin-right: 12px;

          /deep/ svg {
            transform: translateY(2px);
          }
        }
      }
    }

    &-label {
      color: $default-white;
      font-weight: 400;
      @include respond-to(medium) {
        display: none;
      }
    }

    &-menu {
      max-width: 800px;
    }

    &-content {
      color: $col-text;
      @include font('main', $font-size-m, 400);
      white-space: normal;

      &.nav__notifications-content_indent {
        padding-left: 16px;
      }
    }

    &-item:not(:nth-child(1)) {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 16px;
        width: calc(100% - 32px);
        height: 1px;
        background-color: rgba(0,0,0,.2);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/Notifications.vue